export const getSummaryCardsConfig = (currentAccountStatus, financialSummary) => [
    {
        icon: "ri-wallet-line",
        title: "Account Balance",
        value: currentAccountStatus.accountBalance,
        color: "primary",
        iconBg: "#e3f2fd"
    },
    {
        icon: "ri-gamepad-line",
        title: "Total Bids",
        value: financialSummary.totalBidsPlaced,
        color: "info",
        iconBg: "#e0f7fa"
    },
    {
        icon: "ri-money-dollar-circle-line",
        title: "Total Spent",
        value: financialSummary.totalAmountSpent,
        color: "danger",
        iconBg: "#ffebee"
    },
    {
        icon: "ri-trophy-line",
        title: "Total Won",
        value: financialSummary.totalAmountWon,
        color: "success",
        iconBg: "#e8f5e9"
    }
];